import { useCreateProductStore } from "../useCreateProductStore";

export const useTestCasePolicy = () =>
  useCreateProductStore((state) => ({
    policies: state.testCasePolicies,
    storeTestCasePolicies: state.storeTestCasePolicies,
    setDisabled: state.setDisabled,
  }));
